import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavView = _resolveComponent("NavView")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createVNode(_component_NavView),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}